import React, { Component } from 'react'
import '../styles/CartItem.css'
import CalendarIcon from '../images/Booking/calendar-blue.png'
import GlobeIcon from '../images/Booking/globe.png'
import PlayerIcon from '../images/Booking/player-icon.png'
import MagnifierIcon from '../images/Cart/magnifier.png'
import CupCakeIcon from '../images/Booking/cupcake.png'
import PopIn from './PopIn'
import VBNCustom1 from '../images/Themes/VBN/vbn-custom-1.png'
import VBNCustom2 from '../images/Themes/VBN/vbn-custom-2.png'
import VBNCustom3 from '../images/Themes/VBN/vbn-custom-3.png'
import LAIcon from '../images/Themes/icon-small-la.png'
import VBNIcon from '../images/Themes/icon-small-vbn.png'
import AbattoirIcon from '../images/Themes/icon-small-abattoir.png'
import YakuzaIcon from '../images/Themes/icon-small-yakuza.png'
import TombeauIcon from '../images/Themes/icon-small-tombeau.png'
import { API_ROOT } from '../api-config'
import { Cookies } from 'react-cookie-banner'
import { injectIntl, defineMessages } from "react-intl"

const formatDateWithZero = (date) => {
  if (date) {
    const formattedDate = date.split("-")
    let y, M, d

    y = formattedDate[0]
    M = formattedDate[1].length < 2 ? `0${formattedDate[1]}` : formattedDate[1]
    d = formattedDate[2].length < 2 ? `0${formattedDate[2]}` : formattedDate[2]

    return `${d}/${M}/${y}`  
  }
  
  return "";
}

const formatLanguage = (lang) => {
  switch (lang) {
    case 'fr':
      return 'Français'
    case 'en':
      return 'English'
    default:
      break
  }
}

const themeCodeConverter = (code) => {
  
  switch (code) {
        case '27':
          return messages.la
        case '28':
          return messages.VBN
        case '29':
          return messages.slaughterhouse
        case '31':
          return messages.yakuza
        case '32':
          return messages.tombeau
        default:
          break
      }
}

const themeIconConverter = (code) => {
  switch (code) {
    case '27':
      return LAIcon
    case '28':
      return VBNIcon
    case '29':
      return AbattoirIcon
    case '31':
      return YakuzaIcon
    case '32':
      return TombeauIcon
    default:
      break
  }
}

const buildFormBody = (body) => {
  let formBody = []

  for (let property in body) {
    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(body[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }

  formBody = formBody.join("&")

  return formBody
}

class CartItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      customized: false,
      showPopIn: false,
      isVnbDisabled: false
    }
  }

  formatDate = (date, slot) => {
    if (date) {
      const slotHour = slot.split(":")[0]
      const slotMinutes = slot.split(":")[1]

      if (this.props.lang === "fr") {
        return `${formatDateWithZero(date)}, à ${slotHour}h${slotMinutes}`
      } else {
        return `${formatDateWithZero(date)}, ${slotHour}h${slotMinutes}`
      }
    }
  
    return "";
  }

  toggleOption = async (optionId, resaId, resaToken, hasOption) => {
    if (this.state.isVnbDisabled) {
      return;
    }
    this.setState({isVnbDisabled: true});
    let body = {
      id_reservation: resaId,
      token_reservation: this.findToken(resaId),
      id_room_option: optionId
    }

    const url = hasOption ? `${API_ROOT}FrontDeleteOptionFromReservation.php` : `${API_ROOT}FrontAddOptionToReservation.php`

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(data => {
      this.props.updateBookings(data)
      this.setState({ customized: !this.state.customized, isVnbDisabled: false })
    })
    .catch(error => {console.log(error); this.setState({isVnbDisabled: false});})
  }

  findToken = (id) => {
    const cookies = new Cookies()
    return cookies.get("bookingsTokens").filter(x => x.id_room_reservation == id).shift().id_room_reservation_token
  }

  componentDidMount() {
    if (this.props.slot.room_option_name) {
      this.setState({ customized: true })
    }
  }

  render() {
    const {intl:{formatMessage}} = this.props
    const slot = this.props.slot
    let r;

    if (this.props.readOnly) {
      r = (
          <div className="cart-item-readonly-element">
            <p>{formatMessage(themeCodeConverter(slot.room_id))}</p>
            <p>{this.formatDate(slot.reservation_date, slot.time_begin)} / {`${slot.quantity_player} ${formatMessage(messages.players)}`} / {formatLanguage(slot.lang)}</p>
            <p>{Math.floor(slot.price_reservation_total)},{(Math.round((slot.price_reservation_total % 1) * 100) / 100).toFixed(2).split(".")[1]} €</p>
          </div>
        )
    } else {
      r = (
      <div className="cart-item">
        <div className="cart-item-header cart-item-section">
          <img src={themeIconConverter(slot.room_id)} alt="" style={{ marginRight: "12px"}}/>
          <p>{formatMessage(themeCodeConverter(slot.room_id))}</p>
          {
            this.props.deletable
            ? <span className="cart-item-close" onClick={() => this.props.handleDelete(slot)}></span>
            : null
          }
        </div>
        <div className="cart-item-details cart-item-section">
          <div className="cart-item-details-block"><img src={CalendarIcon} alt=""/>{this.formatDate(slot.reservation_date, slot.time_begin)}
          </div>
          <div className="cart-item-details-block"><img src={PlayerIcon} alt=""/>{`${slot.quantity_player} ${formatMessage(messages.players)}`}
          </div>
          <div className="cart-item-details-block"><img src={GlobeIcon} alt=""/>{formatLanguage(slot.lang)}
          </div>
        </div>
        <div className="cart-item-price cart-item-section">
          <div style={{ display: "flex", alignItems: "center" }}>
            <p>{formatMessage(messages.reservationPrice)}</p>
          </div>
          <h3>{Math.floor(slot.reservation_price_without_promo)},{(Math.round((slot.reservation_price_without_promo % 1) * 100) / 100).toFixed(2).split(".")[1]} €</h3>
        </div>
        <div class="cart-items-collapsible-line"></div>
        {
          slot.room_id === "28" && !this.props.locked
          ?
            <div className={this.state.customized ? "cart-item-customization cart-item-customization--customized" : "cart-item-customization"}>
              <img src={CupCakeIcon} alt=""/>
              <p class="cart-item-customization-title">{formatMessage(messages.customizationOption)}</p>
                  <div>
                    <p>{formatMessage(messages.customizationAvailability)}</p>
                    <p className="customization-learn-more" onClick={() => this.setState({ showPopIn: !this.state.showPopIn })}>{formatMessage(messages.learnMore)} <span className="customization-question-mark">?</span></p>
                    <h3>50,00 €</h3>
                  </div>
              <div style={{ display: "flex", justifyContent: "space-between"}}>


                    <div
                      className="cart-form-checkbox cart-form-checkbox--checked cart-item-form-checkbox"
                      onChange={() => this.toggleOption(3, slot.id, slot.id_room_reservation_token, this.state.customized)}>
                      <label><input type="checkbox" disabled={this.state.isVnbDisabled} className="cart-form-check cart-voucher-element-checkbox" checked={this.state.customized}></input><span class="checkmark"></span>{formatMessage(messages.customizationAdd)}</label>
                    </div>
                {
                  this.state.customized
                  ? <h3 className="cart-item-customization-price--checked">{formatMessage(messages.customizationPrice)}</h3>
                  : null
                }
              </div>
            </div>
          : null
        }
        {
          this.state.showPopIn
          ?
            <PopIn
              closePopIn={() => this.setState({ showPopIn: false })}
              title={formatMessage(messages.title)}
            >
              <p className="pop-in-baseline">{formatMessage(messages.baseline)}</p>
              <div className="pop-in-content">
                <h4>{formatMessage(messages.contentTitle)}</h4>
                <p>- {formatMessage(messages.content1)}</p>
                <p>- {formatMessage(messages.content2)}</p>
                <p>- {formatMessage(messages.content3)}</p>
                <p>{formatMessage(messages.content4)}</p>
                <div className="pop-in-custom-container">
                <p className="pop-in-custom-label">{formatMessage(messages.idealFor)}</p>
                  <div className="pop-in-custom-card">
                    <div
                      className="pop-in-custom-icon"
                      style={{backgroundImage: `url(${VBNCustom1})`}}
                      ></div>
                    <div className="pop-in-custom-text">{formatMessage(messages.idealForContent1)}</div>
                  </div>
                  <div className="pop-in-custom-card">
                    <div
                      className="pop-in-custom-icon"
                      style={{backgroundImage: `url(${VBNCustom2})`}}
                      ></div>
                    <div className="pop-in-custom-text">{formatMessage(messages.idealForContent2)}</div>
                  </div>
                  <div className="pop-in-custom-card">
                    <div
                      className="pop-in-custom-icon"
                      style={{backgroundImage: `url(${VBNCustom3})`}}
                      ></div>
                    <div className="pop-in-custom-text">{formatMessage(messages.idealForContent3)}</div>
                  </div>
                </div>
              </div>
              <div className="pop-in-footer">
                <p>{formatMessage(messages.footer)}</p>
              </div>
            </PopIn>
          : null
        }
      </div>
    )
    }

    return r;
  }
}

const messages = defineMessages({
  la: {
    id: 'themes.la',
    defaultMessage: 'Lost Asylum'
  },
  VBN: {
    id: 'themes.VBN',
    defaultMessage: 'Very Bad Night'
  },
  slaughterhouse: {
    id: 'themes.slaughterhouse',
    defaultMessage: "L'abattoir"
  },
  yakuza: {
    id: 'themes.yakuza',
    defaultMessage: "Mission Yakuza"
  },
  tombeau: {
    id: 'themes.tombeau',
    defaultMessage: "L'Expédition Maudite"
  },
  players: {
    id: 'cartItem.players',
    defaultMessage: 'joueurs'
  },
  reservationPrice: {
    id: 'cartItem.reservationPrice',
    defaultMessage: 'Prix de la partie'
  },
  customizationOption: {
    id: 'cartItem.customizationOption',
    defaultMessage: 'Option de personnalisation'
  },
  customizationPrice: {
    id: 'cartItem.customizationPrice',
    defaultMessage: '50 €'
  },
  customizationAvailability: {
    id: 'cartItem.customizationAvailability',
    defaultMessage: 'Disponible uniquement 3 jours avant la réservation'
  },
  learnMore: {
    id: 'cartItem.learnMore',
    defaultMessage: 'En savoir plus'
  },
  customizationAdd: {
    id: 'cartItem.customizationAdd',
    defaultMessage: 'Ajouter cette option'
  },
  title: {
    id: 'popinVBNCustom.title',
    defaultMessage: 'Option de personnalisation'
  },
  baseline: {
    id: 'popinVBNCustom.baseline',
    defaultMessage: 'Pour 50€ en plus de votre session de jeu.'
  },
  contentTitle: {
    id: 'popinVBNCustom.contentTitle',
    defaultMessage: 'Voici ce que nous vous proposons :'
  },
  content1: {
    id: 'popinVBNCustom.content1',
    defaultMessage: "Création d'un gâteau sur mesure"
  },
  content2: {
    id: 'popinVBNCustom.content2',
    defaultMessage: "Personnalisation d'une énigme pour la personne sélectionnée"
  },
  content3: {
    id: 'popinVBNCustom.content3',
    defaultMessage: "Personnalisation de l'ambiance (playlist personnalisée...)"
  },
  content4: {
    id: 'popinVBNCustom.content4',
    defaultMessage: "Pour cela il nous vous enverrons un petit questionnnaire dans lequel vous devrez nous donner plus d’infos sur la personne concernée :  son nom / surnom, des photos embarassantes ou non, sa playlist etc…"
  },
  idealFor: {
    id: 'popinVBNCustom.idealFor',
    defaultMessage: "Idéal pour :"
  },
  idealForContent1: {
    id: 'popinVBNCustom.idealForContent1',
    defaultMessage: "Anniversaires"
  },
  idealForContent2: {
    id: 'popinVBNCustom.idealForContent2',
    defaultMessage: "EVG / EFG"
  },
  idealForContent3: {
    id: 'popinVBNCustom.idealForContent3',
    defaultMessage: "Un peu de piment :)"
  },
  footer: {
    id: 'popinVBNCustom.footer',
    defaultMessage: "Pour profiter de cette option, rendez-vous dans votre réservation Very Bad Night !"
  },
})



export default injectIntl(CartItem)



// WEBPACK FOOTER //
// ./src/components/CartItem.js